export default "__VITE_ASSET__0aM_Xcao__"